import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Table,
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { FaPlus, FaMinus } from "react-icons/fa6";
import {
  addItem,
  removeItem,
  deleteItem,
  updateItem,
} from "../../slices/cart/reducer";

import { useFormik } from "formik";

import SimpleBar from "simplebar-react";
import { DiscountModal } from "./components/DiscountModal";

interface CartItemsProps {
  setActiveTab: (tab: string) => void;
  cart: any;
}

const CartItems: React.FC<CartItemsProps> = ({ setActiveTab, cart }) => {
  const dispatch = useDispatch();
  const [isDiscountModalOpen, setIsDiscountModalOpen] =
    useState<boolean>(false);
  const [activeMenuIndex, setActiveMenuIndex] = useState<number | null>(null);
  const [selectedOrderItem, setSelectedOrderItem] = useState(null);
  const [quantity, setQuantity] = useState(0);

  const defaultCurrency = useSelector(
    (state: any) => state.Login.default_currency
  );

  const toggleMenu = (index: number) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const toggleDiscountModal = async (item: any) => {
    await setSelectedOrderItem(item);
    setIsDiscountModalOpen(!isDiscountModalOpen);
  };

  const handleDeleteClick = (item: any) => {
    dispatch(deleteItem(item.id));

    // setDeleteModal(true);
  };

  const formik = useFormik({
    initialValues: {
      items: cart,
    },
    onSubmit: (values) => {
      setActiveTab("2");
    },
  });

  return (
    <>
      <DiscountModal
        isOpen={isDiscountModalOpen}
        toggle={toggleDiscountModal}
        orderItem={selectedOrderItem}
      />

      <Card className="shadow-none">
        <CardBody className="p-4">
          <CardTitle tag="h4" className="mb-4 text-primary">
            Shopping Cart
          </CardTitle>

          <form onSubmit={formik.handleSubmit}>
            {cart && cart.length > 0 ? (
              <>
                <div className="cart-items mb-4">
                  <h5 className="text-dark mb-3 border-bottom pb-2">
                    Cart Items
                  </h5>
                  <SimpleBar
                    className="cart-items-scroll"
                    style={{ maxHeight: "360px" }}
                    autoHide={false}
                  >
                    <Table responsive className="table-borderless mb-0">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th className="text-center">
                            Price({defaultCurrency})
                          </th>
                          <th className="text-center">Quantity</th>
                          <th className="text-center">
                            Discount({defaultCurrency})
                          </th>
                          <th className="text-end">Total({defaultCurrency})</th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cart.map((item: any, index: number) => (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex align-items-center">
                                {/* {item.imageUrl && (
                                  <img
                                    src={item.imageUrl}
                                    alt={item.name}
                                    className="rounded"
                                    width="50"
                                    height="50"
                                    style={{ objectFit: "cover" }}
                                  />
                                )} */}
                                <span className="ms-2">
                                  {item?.name || item?.product?.name}
                                </span>
                              </div>
                            </td>
                            <td className="text-center align-middle">
                              {item.price && Number(item.price).toFixed(2)}
                            </td>

                            <td className="text-center align-middle">
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                <Button
                                  color="light"
                                  size="sm"
                                  onClick={() => dispatch(removeItem(item.id))}
                                  // disabled={item.quantity <= 0.1}
                                >
                                  <FaMinus size={12} />
                                </Button>
                                <Input
                                  type="number"
                                  step={0.1}
                                  min={0.1}
                                  value={item.quantity}
                                  onChange={(e) => {
                                    // setQuantity(item.quantity);
                                    dispatch(
                                      updateItem({
                                        ...item,
                                        quantity: e.target.value,
                                      })
                                    );
                                  }}
                                  onFocus={() => setQuantity(item.quantity)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                      e.currentTarget.blur();
                                      e.preventDefault();
                                    }
                                  }}
                                  onBlur={(e) => {
                                    if (e.target.value === "") {
                                      dispatch(
                                        updateItem({
                                          ...item,
                                          quantity: quantity,
                                        })
                                      );
                                    }
                                  }}
                                  className="mx-2"
                                  style={{
                                    minWidth: "80px",
                                    padding: "0.2rem 0.1rem",
                                    maxWidth: "80px",
                                    textAlign: "center",
                                  }}
                                />
                                <Button
                                  color="light"
                                  size="sm"
                                  onClick={() =>
                                    dispatch(addItem({ id: item.id, ...item }))
                                  }
                                >
                                  <FaPlus size={12} />
                                </Button>
                              </div>
                            </td>
                            <td className="text-center align-middle">
                              <p className="mb-0">
                                {item?.discount_amt > 0
                                  ? item.discount_amt.toFixed(2)
                                  : item?.discount_percentage > 0
                                  ? (
                                      (item.discount_percentage / 100) *
                                      Number(item.price) *
                                      item.quantity
                                    ).toFixed(2)
                                  : 0}
                              </p>
                            </td>

                            <td className="text-end align-middle">
                              {(
                                Number(item.price) * Number(item.quantity) -
                                (Number(item.discount_amt) +
                                  (item.discount_percentage > 0
                                    ? (item.discount_percentage / 100) *
                                      Number(item.price) *
                                      item.quantity
                                    : 0))
                              ).toFixed(2)}
                            </td>
                            <td className="text-center align-middle">
                              <Dropdown
                                isOpen={activeMenuIndex === index}
                                toggle={() => toggleMenu(index)}
                                direction="end"
                                className="ms-2"
                              >
                                <DropdownToggle tag="a">
                                  <i className="mdi mdi-dots-horizontal font-size-18" />
                                </DropdownToggle>
                                <DropdownMenu>
                                  <DropdownItem
                                    className="text-success"
                                    onClick={() => {
                                      toggleDiscountModal(item);
                                    }}
                                  >
                                    <i className="bx bxs-discount me-2" /> Add
                                    discount
                                  </DropdownItem>
                                  <DropdownItem
                                    className="text-danger"
                                    onClick={() => handleDeleteClick(item)}
                                  >
                                    <i className="mdi mdi-delete me-2" /> Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </SimpleBar>
                </div>

                <div className="order-summary">
                  <h5 className="text-dark mb-3 border-bottom pb-2">
                    Order Summary
                  </h5>
                  <Table className="table-borderless mb-0">
                    <tbody>
                      <tr>
                        <td className="text-muted h5">Total:</td>
                        <td
                          className="text-end h4"
                          style={{ color: "#20B2AA" }}
                        >
                          {defaultCurrency}{" "}
                          {cart
                            .reduce((total: number, item: any) => {
                              const discount =
                                item.discount_amt > 0
                                  ? item.discount_amt
                                  : item.discount_percentage > 0
                                  ? (item.discount_percentage / 100) *
                                    item.price *
                                    item.quantity
                                  : 0;

                              return (
                                total +
                                Math.max(
                                  0,
                                  item.price * item.quantity - discount
                                )
                              );
                            }, 0)
                            .toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      type="submit"
                      color="primary"
                      disabled={cart.length === 0}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center py-4">
                <p>Your cart is empty</p>
              </div>
            )}
          </form>
        </CardBody>
      </Card>
    </>
  );
};

export default CartItems;
